import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Chip, Icon } from '@popmenu/common-ui';
import { Heart } from '@popmenu/web-icons';
import { classNames, makeStyles } from '../../../utils/withStyles';
import { usePop } from '../../hooks/usePop';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: theme.spacing(3),
    color: theme.palette.text.primary,
    cursor: 'unset',
    fontSize: '1rem',
    lineHeight: '2rem',
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(3, 0.5),
    textTransform: 'none',
  },
  clickable: {
    // Keep the focus background for keyboard users only, so a tap doesn't leave the chip looking selected
    '&:focus:not(.Mui-focusVisible)': {
      backgroundColor: 'transparent',
    },
    cursor: 'pointer',
  },
  icon: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
    position: 'relative',
    top: '6px',
  },
  poppedIcon: {
    color: theme.palette.error.main,
    fill: 'currentColor',
  },
}));

type DishLikesButtonProps = {
  isPoppable: boolean
  menuItemId: number
  popsCount: number
}

export const DishLikesButton = ({ isPoppable, menuItemId, popsCount }: DishLikesButtonProps) => {
  const classes = useStyles();
  const { isPopped, togglePop } = usePop({ menuItemId, popsCount });

  return (
    <Chip
      aria-pressed={isPoppable ? isPopped : undefined}
      className={classNames(classes.button, isPoppable && classes.clickable)}
      label={(
        <React.Fragment>
          <Icon className={classNames(classes.icon, isPopped && classes.poppedIcon)} icon={Heart} />
          <FormattedMessage
            defaultMessage="{popsCount, plural, one {# like} other {# likes}}"
            values={{
              popsCount,
            }}
          />
        </React.Fragment>
      )}
      onClick={isPoppable ? () => { void togglePop(); } : undefined}
      variant="outlined"
    />
  );
};
